import { t } from '@base/utils/helpers';
import Flag from '@ui-kit/components/flag';
import { PlayerStatistics } from '../user/model/interfaces';

type PropsType = {
  player: PlayerStatistics;
  handleVisibleChange?: () => void;
};

export const PlayerStastisticInfo = ({
  player,
  handleVisibleChange,
}: PropsType) => {

  return (
    <div className="player-additional-info">
      <header className="player-additional-info__header">
        <div className="player-additional-info__player-card">
        <div className='avatar-overlay' style={{height: '60px', width: '60px'}}>
            <img className='avatar' src={`https://gamecolony.com/cgi-bin/get_avatar.plx?size=6&uid=${player.UserID}`} alt={player.Name} />
          </div>
          {/* https://gamecolony.com/cgi-bin/get_avatar.plx?size=6&uid=${player.userID} */}
          <div className="player-additional-info__user">
            <span>{player.Name}</span>
            <div className="player-additional-info__user-rating">
              <Flag
                countryCode={player.Ccode}
                style={{ marginRight: '.8rem' }}
              />
              {/* <Rating>{player.getRating()}</Rating> */}
            </div>
          </div>
        </div>
        <div className="player-additional-info__status">
        </div>
      </header>

      <div className="player-additional-info__params">
        {/*top3*/}
        <span>{t('tourneys')}</span>
        <span>{`${
          player.NTourneysWon
        } ${t('of')} ${player.NTourneys}`}</span>

        {/*mini*/}
        <span>{t('tourneys_games')}</span>
        <span>{`${player.NTrnGamesWon} ${t('of')} ${player.NTrnGamesWon}`}</span>

        {/*ladder ranked*/}
        <span>{t('ladder_ranking')}</span>
        <span>{!player.Rank || player.Rank < 0 ? t('none') : player.Rank}</span>

        {/*total game/*/}
        <span>{t('total_games')}</span>
        <span>{player.NGames}</span>

        <span>{t('won')}</span>
        <span>{player.NWon}</span>

        <span>{t('best_rank')}</span>
        <span>{!player.BestRank ? t('none') : player.BestRank}</span>
      </div>

      <footer className="player-additional-info__footer">
      </footer>
    </div>
  );
};
